import gql from "graphql-tag";

export const FullComponentFragment = gql`
    fragment FullComponent on Component {
        id
        slug
        stage
        title
        headline
        description
        podcasts {
            id
            title
            shortdescription
            publicationDate
        }
        sections(orderBy: sortIndex_ASC) {
            id
            slug

            headline
            description
            table

            assetsWithDescription(orderBy: sortIndex_ASC) {
                id
                asset(locales: [$lang, de]) {
                    handle
                    fileName
                    width
                    height
                    url
                    mimeType
                }

                description
                localizedAsset {
                    handle
                    fileName
                    width
                    height
                    url
                    mimeType
                }
            }
        }
    }
`;

export default gql`
    query Component($slug: String!, $lang: Locale!, $stage: Stage!) {
        component(where: { slug: $slug }, locales: [$lang], stage: $stage) {
            ...FullComponent
        }
    }
    ${FullComponentFragment}
`;



// WEBPACK FOOTER //
// ./src/queries/component.js